import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import moment from 'moment';
import { getCalendarViewByDevice } from '../utils/deviceDetection';
import { getAuthProviderRedirectUrl } from '../http-client/auth-redirect';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  // auth routes
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/index.vue'),
    children: [
      {
        path: 'confirmsession',
        name: 'confirmsession',
        component: () => import('../views/auth/confirmsession.vue'),
        meta: {
          title: 'Verificando sesión',
        },
      },
    ],
  },
  // app routes
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'app-home',
        // component: () => import('../views/app/home.vue'),
        meta: {
          title: 'Inicio',
        },
        redirect: () => ({
          name: getCalendarViewByDevice(),
          params: { date: moment().format('YYYY-MM-DD') },
        }),
      },
      // calendar
      {
        path: 'calendar',
        name: 'app-calendar',
        component: () => import('../views/app/calendar/index.vue'),
        meta: {
          title: 'Calendar',
        },
        redirect: () => ({
          name: getCalendarViewByDevice(),
          params: { date: moment().format('YYYY-MM-DD') },
        }),
        children: [
          {
            path: 'share',
            name: 'app-calendar-share',
            component: () => import('../views/app/calendar/share.vue'),
            meta: {
              title: 'Create Event',
            },
          },
          {
            path: 'day/:date?',
            name: 'app-calendar-day',
            component: () => import('../views/app/calendar/day.vue'),
            meta: {
              title: 'Day',
            },
          },
          {
            path: 'week/:date?',
            name: 'app-calendar-week',
            component: () => import('../views/app/calendar/day.vue'),
            meta: {
              title: 'Week',
            },
          },
          {
            path: 'labour/:date?',
            name: 'app-calendar-labour',
            component: () => import('../views/app/calendar/day.vue'),
            meta: {
              title: 'Labour Days',
            },
          },
          {
            path: 'month/:date?',
            name: 'app-calendar-month',
            component: () => import('../views/app/calendar/day.vue'),
            meta: {
              title: 'Month',
            },
          },
          {
            path: 'year/:date?',
            name: 'app-calendar-year',
            component: () => import('../views/app/calendar/day.vue'),
            meta: {
              title: 'Year',
            },
          },
        ],
      },
      // events
      {
        path: 'events',
        name: 'app-events',
        component: () => import('../views/app/events/index.vue'),
        meta: {
          title: 'Events',
        },
        children: [
          {
            path: 'new',
            name: 'app-events-new',
            component: () => import('../views/app/events/new.vue'),
            meta: {
              title: 'New Event',
            },
          },
          {
            path: ':id',
            name: 'app-events-details',
            component: () => import('../views/app/events/details.vue'),
            meta: {
              title: 'Event Details',
            },
          },
        ],
      },
      // integrations
      {
        path: 'integrations',
        name: 'app-integrations',
        component: () => import('../views/app/integrations.vue'),
        meta: {
          title: 'Integrations',
        },
      },
      // rsvp
      {
        path: 'rsvp',
        name: 'app-rsvp',
        component: () => import('../views/app/rsvp.vue'),
        meta: {
          title: 'Event RSVP',
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Set title
  if (to.meta.title) {
    document.title = `${to.meta.title} - digi-calendar`;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!localStorage.getItem('token')) {
      const url = getAuthProviderRedirectUrl();
      console.log('url', url);
      window.location.href = url;
      return next(false);
    }
  }

  if (to.query.redirect && !to.path.startsWith('/auth')) {
    // redirect to the to path
    return next(to.query.redirect as string);
  }

  return next();
});

export default router;
